var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurvedArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 40,
    viewBox: "0 0 29 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6892 31.511C29.1036 31.9217 29.1036 32.5877 28.6892 32.9984L21.9373 39.6919C21.5229 40.1027 20.8512 40.1027 20.4368 39.6919C20.0225 39.2812 20.0225 38.6152 20.4368 38.2045L25.3776 33.3065L16.6533 33.3065C7.45592 33.3065 6.49943e-06 25.8506 1.26235e-05 16.6532L2.28418e-05 1.06097C2.28674e-05 0.475012 0.475037 -1.24686e-06 1.061 -1.22125e-06C1.64695 -1.19564e-06 2.12197 0.475011 2.12197 1.06097L2.12196 15.6015C2.12195 24.2179 9.10696 31.2029 17.7234 31.2029L25.3776 31.2029L20.4368 26.3049C20.0225 25.8942 20.0225 25.2282 20.4368 24.8175C20.8512 24.4067 21.5229 24.4067 21.9373 24.8175L28.6892 31.511Z",
    fill: "#00B061"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurvedArrow);
export default __webpack_public_path__ + "static/media/curvedArrow.bd4397280719b18b63f2880170e5bb6a.svg";
export { ForwardRef as ReactComponent };